let pageContext = null
export const setAnnaWorkspaceContext = context => {
    pageContext = context
}
export const getAnnaWorkspaceContext = () => pageContext
